(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6088],{

/***/ 17747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rd": function() { return /* binding */ openCheckout; },
/* harmony export */   "cq": function() { return /* binding */ initCheckoutObject; },
/* harmony export */   "mN": function() { return /* binding */ checkOutInline; },
/* harmony export */   "vT": function() { return /* binding */ initSingleLineProposition; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);


var initCheckoutObject = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(affirm, order) {
        var customer, billingAddress, hostname, checkOutObjForAffirm;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            customer = order.customer ? order.customer : {};
            billingAddress = order.billingAddress || {};
            if (order && order.cartlist && order.cartlist.cart && order.cartlist.bigCommerceCart && customer) {
                hostname = "https://localhost/checkout/";
                if (true) {
                    hostname = "https://".concat(window.location.hostname, "/checkout");
                }
                checkOutObjForAffirm = {
                    merchant: {
                        user_confirmation_url: hostname,
                        user_cancel_url: hostname
                    },
                    user_confirmation_url_action: "GET",
                    metadata: {
                        mode: "modal"
                    },
                    shipping: {
                        name: {
                            full: "".concat(customer.first_name, " ").concat(customer.last_name)
                        },
                        address: {
                            line1: billingAddress.address1,
                            city: billingAddress.city,
                            state: billingAddress.state_or_province_code,
                            zipcode: billingAddress.postal_code,
                            country: billingAddress.country
                        }
                    },
                    items: [],
                    shipping_amount: (order.checkout.shipping_cost_total_ex_tax + order.checkout.handling_cost_total_ex_tax * 100).toFixed(),
                    tax_amount: (order.checkout.tax_total * 100).toFixed(),
                    total: (order.grand_total * 100).toFixed()
                };
                // Need to Add Non Physical Items Here
                order.cartlist.bigCommerceCart.line_items.physical_items.forEach(function(item) {
                    checkOutObjForAffirm.items.push({
                        display_name: item.name,
                        sku: item.sku,
                        unit_price: (item.list_price * 100).toFixed(),
                        qty: item.quantity,
                        item_image_url: item.image_url,
                        item_url: item.url
                    });
                });
                return [
                    2,
                    checkOutObjForAffirm
                ];
            } else {
                throw "SOMETHING WENT WRONG INITIALIZING CHECKOUT OBJ";
            }
            return [
                2
            ];
        });
    });
    return function initCheckoutObject(affirm, order) {
        return _ref.apply(this, arguments);
    };
}();
var initSingleLineProposition = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(affirm, item, id) {
        var price;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            price = item.price * 100;
            affirm.checkout({
                total: price
            });
            return [
                2
            ];
        });
    });
    return function initSingleLineProposition(affirm, item, id) {
        return _ref.apply(this, arguments);
    };
}();
var openCheckout = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(affirm, checkoutObj, setAffirmTokenState, isValidated) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            affirm.checkout(checkoutObj);
            affirm.checkout.open({
                onFail: function onFail() {
                    console.log("User cancelled the Affirm checkout flow");
                },
                onSuccess: function onSuccess(a) {
                    console.log("Affirm checkout successful, checkout token is: " + a.checkout_token);
                    setAffirmTokenState(a.checkout_token);
                    isValidated();
                }
            });
            return [
                2
            ];
        });
    });
    return function openCheckout(affirm, checkoutObj, setAffirmTokenState, isValidated) {
        return _ref.apply(this, arguments);
    };
}();
var checkOutInline = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(affirm, checkoutObj, ID) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            affirm.checkout(checkoutObj);
            affirm.checkout.inline({
                merchant: {
                    inline_container: ID
                }
            });
            return [
                2
            ];
        });
    });
    return function checkOutInline(affirm, checkoutObj, ID) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InputContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _input_container_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78574);
/* harmony import */ var _input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6__);







var InputContainer = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(InputContainer, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(InputContainer);
    function InputContainer() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, InputContainer);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(InputContainer, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "input-container-wrapper",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row-items",
                            children: [
                                !this.props.labelAfterInput && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    htmlFor: this.props.id,
                                    className: (_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                                    children: [
                                        this.props.label,
                                        " ",
                                        this.props.helpText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: (_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default().helpText),
                                            children: [
                                                "(",
                                                this.props.helpText,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                this.props.body,
                                this.props.labelAfterInput && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    htmlFor: this.props.id,
                                    className: (_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                                    children: [
                                        this.props.label,
                                        " ",
                                        this.props.helpText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: (_input_container_module_scss__WEBPACK_IMPORTED_MODULE_6___default().helpText),
                                            children: [
                                                "(",
                                                this.props.helpText,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        this.props.validationError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "alert alert-danger",
                            role: "alert",
                            children: this.props.validationError.props.children
                        })
                    ]
                });
            }
        }
    ]);
    return InputContainer;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 19405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextInput; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_phone_number_input_input__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91310);
/* harmony import */ var _InputContainer_input_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(831);








var TextInput = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(TextInput, _PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(TextInput);
    function TextInput() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, TextInput);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(TextInput, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InputContainer_input_container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    validationError: this.props.validationError,
                    id: this.props.id,
                    label: this.props.label,
                    helpText: this.props.optional ? "Optional" : "",
                    width: this.props.width,
                    labelAfterInput: this.props.labelAfterInput,
                    body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_phone_number_input_input__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                        disabled: this.props.disabled,
                        name: this.props.name,
                        country: "US",
                        type: this.props.type ? this.props.type : "tel",
                        id: this.props.id,
                        value: this.props.value || "",
                        required: !this.props.optional,
                        onChange: this.props.onChange,
                        placeholder: this.props.placeholder,
                        className: "form-control"
                    })
                });
            }
        }
    ]);
    return TextInput;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 67407:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var Loader = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Loader, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Loader);
    function Loader() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, Loader);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Loader, [
        {
            key: "render",
            value: function render() {
                if (this.props.fullscreen) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                                children: "\n						.circle-loader {\n							position: absolute;\n							top: 50%;\n							left: 50%;\n							width: 50%;\n							z-index: 100;\n							text-align: center;\n							transform: translate(-50%, -50%);\n						}\n\n						.circle-loader .circle {\n							fill: transparent;\n							stroke: rgba(0, 0, 0, 0.5);\n							stroke-width: 4px;\n							animation: dash 2s ease infinite, rotate 2s linear infinite;\n						}\n\n						@keyframes dash {\n							0% {\n								stroke-dasharray: 1, 95;\n								stroke-dashoffset: 0;\n							}\n							50% {\n								stroke-dasharray: 85, 95;\n								stroke-dashoffset: -25;\n							}\n							100% {\n								stroke-dasharray: 85, 95;\n								stroke-dashoffset: -93;\n							}\n						}\n\n						@keyframes rotate {\n							0% {\n								transform: rotate(0deg);\n							}\n							100% {\n								transform: rotate(360deg);\n							}\n						}\n					"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "circle-loader",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "circle",
                                    width: "60",
                                    height: "60",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                        cx: "30",
                                        cy: "30",
                                        r: "15"
                                    })
                                })
                            })
                        ]
                    });
                } else {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                                children: "\n            .circle-loader {\n              display: block;\n              text-center;\n              padding-left: 50%;\n            }\n\n            .circle-loader .circle {\n              position: relative;\n              left: -30px;\n              fill: transparent;\n              stroke: rgba(0,0,0,0.5);\n              stroke-width: 4px;\n              animation: dash 2s ease infinite, rotate 2s linear infinite;\n            }\n\n            @keyframes dash {\n              0% {\n                stroke-dasharray: 1,95;\n                stroke-dashoffset: 0;\n              }\n              50% {\n                stroke-dasharray: 85,95;\n                stroke-dashoffset: -25;\n              }\n              100% {\n                stroke-dasharray: 85,95;\n                stroke-dashoffset: -93;\n              }\n            }\n\n            @keyframes rotate {\n              0% {transform: rotate(0deg); }\n              100% {transform: rotate(360deg); }\n            }\n          "
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "circle-loader",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    className: "circle",
                                    width: "60",
                                    height: "60",
                                    version: "1.1",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                        cx: "30",
                                        cy: "30",
                                        r: "15"
                                    })
                                })
                            })
                        ]
                    });
                }
            }
        }
    ]);
    return Loader;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);



/***/ }),

/***/ 38640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Icon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        className: "spinner-icon",
        viewBox: "0 0 50 50",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
            cx: "25",
            cy: "25",
            r: "20",
            fill: "none",
            strokeWidth: "5",
            className: "path"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 58765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _src_components_checkout_components_PhoneInput_phone_input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19405);
/* harmony import */ var _src_components_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67407);
/* harmony import */ var _src_redux_actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89703);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87066);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14416);
/* harmony import */ var react_responsive_modal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31190);
/* harmony import */ var react_select__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(19154);
/* harmony import */ var simple_react_validator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41283);
/* harmony import */ var simple_react_validator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(simple_react_validator__WEBPACK_IMPORTED_MODULE_10__);
















var customStyles = {
    menuList: function(provided, state) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, provided);
    },
    control: function(provided, state) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, provided), {
            background: "#fff",
            minHeight: "33px",
            height: "33px",
            borderRadius: "3px"
        });
    },
    valueContainer: function(provided, state) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, provided), {
            height: "33px",
            padding: "0 6px"
        });
    },
    input: function(provided, state) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, provided), {
            margin: "0px"
        });
    },
    indicatorsContainer: function(provided, state) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, provided), {
            height: "33px"
        });
    }
};
function categorySearch(props) {
    var onSelectionChange = function onSelectionChange(value, index) {
        var newData = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(vehicleData);
        newData[index - 1] = value;
        // In case we select one of the earlier selections
        // reset everything after current selection
        newData = newData.slice(0, index);
        setVehicleData(newData);
        store.dispatch((0,_src_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .getFitmentModels */ .z0)(value.urlSlug, index));
    };
    var verifyFitment = function verifyFitment(latitude, longitude, urlSlug, idToCompare, target) {
        setFitmentStatus("loading");
        var apiUrl = "https://3cg1obtmoj.execute-api.us-west-2.amazonaws.com/checkout/crossreference/products";
        var xrefPath = "".concat(apiUrl, "/").concat(urlSlug, "?&lat=").concat(latitude, "&lng=").concat(longitude);
        axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].get */ .Z.get(xrefPath, {
            crossdomain: true
        }).then(function(data) {
            var isCompatible = (0,lodash__WEBPACK_IMPORTED_MODULE_5__.find)(data.data.product, [
                "bigCommerceId",
                idToCompare
            ]);
            setFitmentStatus(isCompatible ? "success" : "error");
            setModalVisibility(false);
            props.setModalVisibleFromExternal && props.setModalVisibleFromExternal(false);
            // Add target into redux state
            // searhValue is target slug subtracted from the full slug i.e. category is removed. More flexible for multiple categories.
            store.dispatch((0,_src_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .setFitmentTarget */ .BJ)({
                target: target,
                searchValue: urlSlug.split("".concat(props.categorySlug, "-"))[1],
                fullUrlSlug: urlSlug,
                verifiedFitment: {
                    productId: idToCompare,
                    urlSlug: urlSlug,
                    fits: isCompatible ? true : false
                }
            }));
            if (isCompatible) {
                store.dispatch((0,_src_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .setProduct */ .Gr)(isCompatible));
            }
            // Update the delivery address form
            // Fires only on Variables
            props.updateFormValue && props.updateFormValue(target);
        });
    };
    var renderStatusElements = function renderStatusElements() {
        if (fitmentStatus === "loading") {
            return type === "input-label" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "loading",
                children: [
                    " ",
                    "- ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-circle-notch fa-spin"
                    }),
                    " Loading"
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fitment-status loading ".concat(type),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "icon",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fas fa-circle-notch fa-spin"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                children: "Verifying the Fitment"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Please wait..."
                            })
                        ]
                    })
                ]
            });
        }
        if (fitmentStatus === "success") {
            return type === "input-label" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "success",
                children: [
                    " ",
                    "- ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fas fa-check-circle"
                    }),
                    " Fits Your Product"
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fitment-status fits ".concat(type),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "icon",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fas fa-check"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                children: "Fits your"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: vehicleSpecs
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "button-container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: function() {
                                setModalVisibility(true);
                            },
                            children: "Change Vehicle"
                        })
                    })
                ]
            });
        } else if (fitmentStatus === "error") {
            return type === "input-label" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "error",
                children: [
                    " ",
                    "- ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "far fa-ban"
                    }),
                    " Does not fit",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: function() {
                            setModalVisibility(true);
                        },
                        type: "button",
                        children: "Change"
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fitment-status does-not-fit ".concat(type),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "icon",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "far fa-ban"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                children: "Does not fit your"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    vehicleSpecs,
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        onClick: function() {
                                            setModalVisibility(true);
                                        },
                                        className: "change-vehicle",
                                        children: "(Change)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                className: "btn",
                                href: "/category/".concat(urlSlug),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: "View Compatible Products"
                                })
                            })
                        ]
                    })
                ]
            });
        } else if (fitmentStatus === "target-missing") {
            return type === "input-label" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "normal",
                children: [
                    " ",
                    "-",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            setModalVisibility(true);
                        },
                        type: "button",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                className: "fas fa-info-circle"
                            }),
                            " Add Vehicle"
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fitment-status target-missing ".concat(type),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "icon",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fas fa-info-circle"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                children: "Verify fitment with your vehicle"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: function() {
                                        setModalVisibility(true);
                                    },
                                    children: "Add Vehicle"
                                })
                            })
                        ]
                    })
                ]
            });
        }
    };
    var renderFitmentForm = function renderFitmentForm(isExtended) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "fitment-verification ".concat(type, " "),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "inner-wrapper",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "form",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "form-items-container",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h6", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fas fa-info-circle"
                                    }),
                                    " Verify fitment with your vehicle"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "form-items",
                                children: [
                                    (loading || fitmentStatus === "loading") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "loading-container",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "loading",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {})
                                        })
                                    }),
                                    names.map(function(item, index) {
                                        var yearIndex = 2;
                                        var options = props.fitmentOptions[index] ? props.fitmentOptions[index] : [];
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("form-item", {
                                                disabled: !props.fitmentOptions[index]
                                            }, {
                                                "last-index-available": lastIndexAvailable === index
                                            }, {
                                                active: props.fitmentOptions.length - 1 === index
                                            }),
                                            children: [
                                                isExtended && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                                    children: names[index]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_select__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP, {
                                                    styles: customStyles,
                                                    isDisabled: !props.fitmentOptions[index],
                                                    closeMenuOnSelect: true,
                                                    blurInputOnSelect: true,
                                                    // If it's a year selection, sort and reverse
                                                    options: index === yearIndex ? (0,lodash__WEBPACK_IMPORTED_MODULE_5__.reverse)((0,lodash__WEBPACK_IMPORTED_MODULE_5__.sortBy)(options, "label")) : (0,lodash__WEBPACK_IMPORTED_MODULE_5__.sortBy)(options, "label"),
                                                    value: vehicleData[index] ? vehicleData[index] : null,
                                                    placeholder: "Select ".concat(item),
                                                    onChange: function(value) {
                                                        setLoading(true);
                                                        onSelectionChange(value, index + 1);
                                                        setUrlSlug(value.urlSlug);
                                                        setVehicleSpecs(value.searchValue);
                                                        setFitmentStatus("target-missing");
                                                        // If we reached last input submit the form and other actions
                                                        if (index === names.length - 1) {
                                                            verifyFitment(props.geolocation.latitude, props.geolocation.longitude, value.urlSlug, props.idToCompare, value.searchValue);
                                                        }
                                                    }
                                                }),
                                                simpleValidator.current.message(names[index], vehicleData[index], "required")
                                            ]
                                        }, index);
                                    }),
                                    type === "order-page-fitment" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "form-item ".concat(!props.fitmentOptions[names.length] ? "disabled" : ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_src_components_checkout_components_PhoneInput_phone_input__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                disabled: !props.fitmentOptions[names.length],
                                                type: "nestedObject",
                                                label: "Phone Number",
                                                value: "phoneNumber",
                                                placeholder: "Phone Number",
                                                name: "phoneNumber",
                                                onChange: function(val) {
                                                    return setPhoneNumber(val);
                                                }
                                            }),
                                            simpleValidator.current.message("Phone Number", phoneNumber, "required")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    var store = (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(react_redux__WEBPACK_IMPORTED_MODULE_8__/* .ReactReduxContext */ .ET).store;
    var type = props.type, modalVisible = props.modalVisible;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), loading = ref[0], setLoading = ref[1];
    var lastIndexAvailable = props.fitmentOptions - 1;
    var simpleValidator = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(new (simple_react_validator__WEBPACK_IMPORTED_MODULE_10___default())());
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(), forceUpdate = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)([]), vehicleData = ref2[0], setVehicleData = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), phoneNumber = ref3[0], setPhoneNumber = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)("target-missing"), fitmentStatus = ref4[0], setFitmentStatus = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), vehicleSpecs = ref5[0], setVehicleSpecs = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(""), urlSlug = ref6[0], setUrlSlug = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), modalVisibility = ref7[0], setModalVisibility = ref7[1];
    var names = [
        "Make",
        "Model",
        "Year",
        "Engine"
    ];
    var initialCategory = props.categorySlug || "vehicle-batteries-car-or-truck";
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        // Check if we have the fitment data saved
        if (props.fitmentTarget && props.fitmentTarget.searchValue) {
            // console.log('props.fitmentTarget', props.fitmentTarget);
            // Fill necessary variables
            setVehicleSpecs(props.fitmentTarget.target);
            setUrlSlug(props.fitmentTarget.fullUrlSlug); // If we are on checkout page
            if (type === "input-label") {
                // console.log('is input-label')
                // Check if we have saved data
                // Check if any item from the cart is previously checked and valid
                // If at least 1 is true
                if (props.fitmentTarget.verifiedFitment && props.fitmentTarget.verifiedFitment.productId) {
                    // Update redux store
                    props.updateFormValue(props.fitmentTarget.target);
                    var atLeastOneProductFits = false;
                    props.cartProducts && props.cartProducts.forEach(function(element) {
                        if (element.bigCommerceId === props.fitmentTarget.verifiedFitment.productId) {
                            atLeastOneProductFits = props.fitmentTarget.verifiedFitment.fits;
                        }
                    });
                    // Inform component that the product in the cart is verified
                    if (atLeastOneProductFits) {
                        setFitmentStatus("success");
                    } else {
                        setFitmentStatus("error");
                    }
                } else {
                    verifyFitment(props.geolocation.latitude, props.geolocation.longitude, props.fitmentTarget.fullUrlSlug, props.idToCompare, props.fitmentTarget.target);
                }
            } else {
                setUrlSlug("".concat(props.categorySlug, "-").concat(props.fitmentTarget.searchValue));
                // Check the fitment
                verifyFitment(props.geolocation.latitude, props.geolocation.longitude, props.fitmentTarget.fullUrlSlug, props.idToCompare, props.fitmentTarget.target);
            }
        }
        // Get initial models and start building the category ID in case we need it
        store.dispatch((0,_src_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .getFitmentModels */ .z0)(initialCategory, 0));
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        setLoading(false);
    }, [
        props.fitmentOptions
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (fitmentStatus === "initial") {
            setVehicleSpecs("");
        }
    }, [
        fitmentStatus
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_modal__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                classNames: {
                    modal: "fitment-verification-in-modal",
                    closeButton: "close-btn"
                },
                open: modalVisibility || props.modalVisibleFromExternal,
                onClose: function() {
                    props.setModalVisibleFromExternal && props.setModalVisibleFromExternal(false);
                    setModalVisibility(false);
                },
                children: renderFitmentForm(true)
            }),
            renderStatusElements()
        ]
    });
}
var mapStateToProps = function(state) {
    return {
        geolocation: state.geolocation,
        fitmentOptions: state.category.fitmentOptions,
        fitmentTarget: state.category.fitmentTarget,
        category: state.category,
        masterProvider: state.masterProvider
    };
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_8__/* .connect */ .$j)(mapStateToProps, {
    getCategoryProps: _src_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .getCategoryProps */ .tn,
    getFitmentModels: _src_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .getFitmentModels */ .z0,
    setFitmentTarget: _src_redux_actions__WEBPACK_IMPORTED_MODULE_3__/* .setFitmentTarget */ .BJ
})(categorySearch));


/***/ }),

/***/ 78574:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"input-container_container__eoVfQ","fullWidth":"input-container_fullWidth__nOh6f","twoThirdWidth":"input-container_twoThirdWidth__RG72b","halfWidth":"input-container_halfWidth__Er2t4","oneThirdWidth":"input-container_oneThirdWidth__PKzjO","label":"input-container_label__E0eeg","helpText":"input-container_helpText__VwNH6"};

/***/ })

}]);